module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/2024-join-opt-digital-pass-888b8a41d159814f5108161506e07341.png";